import { getPostApi } from "../../callApi/postApi";
import CustomBottom from "../../components/CustomBottom";
import CustomButton from "../../components/CustomButton";
import CustomHeader from "../../components/CustomHeader";
import CustomPagination from "../../components/CustomPagination";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";

export default function Blog() {
  const [nowPage, setnowPage] = useState(1);
  const [allPage, setallPage] = useState(1);
  const [count, setcount] = useState(0);
  const [contentData, setcontentData] = useState(null);
  const router = useNavigate();
  useEffect(() => {
    if (nowPage) {
      getContent();
    }
  }, [nowPage]);
  const getContent = async () => {
    const res = await getPostApi({
      limit: 4,
      page: nowPage,
      post_categories_id: 1,
    });
    if (res?.status == 200) {
      let temp = [...res.data.data.post];
      for (let i = 0; i < res.data.data.post.length; i++) {
        if (res.data.data.post[i]?.content) {
          temp[i].content_json = JSON.parse(res.data.data.post[i]?.content);
          let FirstImg = null;
          let FirstText = null;
          for (let j = 0; j < temp[i].content_json?.html?.length; j++) {
            for (let k = 0; k < temp[i].content_json?.html[j].length; k++) {
              if (
                FirstImg == null &&
                temp[i].content_json.html[j][k].type == "image"
              ) {
                FirstImg = temp[i].content_json?.html[j][k].value;
              } else if (
                FirstText == null &&
                temp[i].content_json.html[j][k].type == "text"
              ) {
                FirstText = temp[i].content_json?.html[j][k].value;
              }
              if (FirstImg != null && FirstText != null) {
                break;
              }
            }
            if (FirstImg != null && FirstText != null) {
              break;
            }
          }
          temp[i].content_json.img = FirstImg;
          temp[i].content_json.text = FirstText;
        }
      }
      setcontentData(temp ?? []);
      setallPage(Math.ceil(res?.data?.data?.count / 4));
      setcount(res?.data?.data?.count);
    }
  };

  return (
    <div className="fade_In">
      <CustomHeader />
      <div className="flex flex-row items-center gap-4  pt-[180px]">
        <div className="  absolute left-[10vw]">
          <p className="font-medium text-[20px] text-[#B36427]">
            ข่าวและกิจกรรม
          </p>
          <div className="flex flex-row gap-3 items-center">
            <p className="font-bold text-[32px] md:text-[64px]">NEWS & EVENT</p>
            {count > 0 ? (
              <div className="text-xl px-2 py-1 rounded-full border-[3px] bg-white border-primary flex flex-col justify-center items-center ">
                {count}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <img src="/img/bgGreen.png" className="w-full object-contain" />
      </div>

      <div className="px-[20px] py-[24px] flex flex-col items-center ">
        <div className="grid grid-cols-1 gap-10 mt-5 mb-5 w-full">
          {contentData?.map((item, i) => {
            return (
              <div
                key={i}
                className="flex flex-col md:flex-row gap-5 items-start  font-medium text-xl bg-white drop-shadow-md  rounded-lg "
              >
                <img
                  src={
                    item?.content_json.img
                      ? "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                        item?.content_json.img
                      : "/img/logo.png"
                  }
                  className="flex-[1] w-full h-full object-cover rounded-lg max-h-[400px]"
                />
                <div className="flex-[1]  flex flex-col px-4 w-full">
                  <p className="text-[#B36427] font-bold text-[24px]">
                    {item.title}
                  </p>
                  <p className="mt-7 font-medium text-lg line-clamp-6 overflow-hidden text-ellipsis ">
                    {item?.content_json?.text != null ? (
                      <div>{parse(item?.content_json?.text)}</div>
                    ) : (
                      <p></p>
                    )}
                  </p>
                  <p className="text-right text-sm text-[#858485] mt-6">
                    {" "}
                    {format(new Date(item.updated_at), "MMMM dd,yyy")} By Admin
                  </p>
                  <CustomButton
                    onClick={() => {
                      router("/blog/" + item.id);
                    }}
                    txt={"อ่านเพิ่มเติม"}
                    classAdditional=" font-semibold text-lg self-end mt-5"
                  />
                </div>
              </div>
            );
          })}
        </div>
        <CustomPagination
          now={nowPage}
          all={allPage}
          onChangePage={(page) => {
            setnowPage(page);
            setTimeout(function () {
              document.documentElement.style.scrollBehavior = "smooth";
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
            }, 500);
          }}
        />
      </div>
      <CustomBottom />
    </div>
  );
}
